import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { generateCognitoPhoneFormat } from '../../CustomerPortalUtil';
import { AvantoCognitoService } from 'src/app/services/avanto-cognito.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: [
    '../../../../../../../node_modules/daemonite-material/css/material.min.css',
    '../customer-authentication.component.scss'
  ]
})
export class ForgotPasswordComponent implements OnInit {

  @Output() confirmVerificationSuccess = new EventEmitter();

  sentVerificationCode: boolean;

  phoneNumber: string

  verificationCode: string
  newPassword: string;
  confirmPassword: string

  constructor(private cognito: AvantoCognitoService) { }

  //TODO: ADD A RE-SEND VERIFICATION CODE HERE!!!

  ngOnInit() {
    this.sentVerificationCode = false;
  }

  sendVerificationCode() {
    this.cognito.forgotPassword(generateCognitoPhoneFormat(this.phoneNumber))
      .then((success) => {
        this.sentVerificationCode = true;
      })
      .catch((error) => {
        console.error(error)
        Swal.fire({ type: 'error', title: "Could not send the verification code", text: "Are you sure this is the right number?" })
      })
  }

  confirm() {
    if (this.newPassword != this.confirmPassword) {
      Swal.fire({ type: 'error', title: "The passwords do not match!" })
      return;
    }

    this.cognito.confirmForgottenPassword(generateCognitoPhoneFormat(this.phoneNumber), this.verificationCode, this.newPassword)
    .then((success) => {
      this.confirmVerificationSuccess.emit();
      Swal.fire({ type: 'success', title: "Your password has been updated" })
    })
    .catch((error) => {
      console.error(error)
      Swal.fire({ type: 'error', title: "Could not change the password", text: "Are you sure this is the right verification code?" })
    })
  }
}
